import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';

const SalePageProductCards = ({ block }) => {
  const items = block.items;
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <>
      <div className="content-wrapper">
        {items.map((item, index) => {
          return (
            <>
              <Link href={item.product_link} key={index}>
                <a
                  className="product-card"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <Image
                    src={
                      hoveredIndex === index
                        ? item.hover_image.url
                        : item.static_image.url
                    }
                    width={item.static_image.dimensions.width}
                    height={item.static_image.dimensions.height}
                    alt={
                      hoveredIndex === index
                        ? item.hover_image.alt
                        : item.static_image.alt
                    }
                  />
                </a>
              </Link>
            </>
          );
        })}
      </div>
      <style jsx>{`
        .content-wrapper {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          background-color: #0f0f0f;
          gap: 20px;
          padding: 20px;
        }
        .product-card {
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
          cursor: pointer;
          overflow: hidden;
          max-width: 450px;
          max-height: 750px;
        }
        .product-card:hover {
          // transform: scale(1.05);
          box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default SalePageProductCards;
